import { types } from 'mobx-state-tree';
import createStore from '../../lib/create-store';

const initState: any = {
  //
};

const defGamsFightInfo = {
  status: 0,
  pkSurplusTimestamp: 0,
  pkEndTimestamp: 0,
  nowTimestamp: 0,
  pkCamps: [],
};

const gamesFightModel = types
  .model({
    isLoaded: false,
    fightType: 'partyVsParty',
  })
  .volatile(() => {
    return {
      info: defGamsFightInfo,
    };
  })
  .views((self) => {
    return {
      get isFighting() {
        return self.info.status === 1;
      },
      get isPartyVsParty() {
        return self.fightType === 'partyVsParty';
      },
      get isSingleVsParty() {
        return self.fightType === 'singleVsParty';
      },
    };
  })
  .actions((self) => {
    const setInfo = (info) => {
      self.info = {
        ...defGamsFightInfo,
        ...info,
      };
      self.isLoaded = true;
    };

    const setFightType = (type: 'partyVsParty' | 'singleVsParty') => {
      self.fightType = type;
    };

    const updateInfo = (info) => {
      self.info = {
        ...self.info,
        ...info,
      };
    };

    return {
      setInfo,
      setFightType,
      updateInfo,
    };
  });

const gamesFightStore = createStore(gamesFightModel, initState);

export default gamesFightStore;
